import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import useLegacyProps from '../../hooks/useLegacyProps.js';
import ICON_NAME_MAP from '../../constants/iconNameMap.js';

var _excluded = ["color", "size", "theme", "ariaHidden"];
var _templateObject;
var DEFAULT_COLOR = 'grayDarker';
var StyledIcon = styled('i')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:before {\n    content: ", ";\n  }\n\n  display: inline-block;\n  font: normal normal normal 15px/1 LfgIcons;\n  font-size: inherit;\n  position: relative;\n  text-rendering: auto;\n\n  color: ", ";\n\n  font-size: ", ";\n"])), function (_ref) {
  var name = _ref.name;
  return "'\\".concat(ICON_NAME_MAP[name], "'");
}, function (_ref2) {
  var _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? DEFAULT_COLOR : _ref2$color,
    inverse = _ref2.inverse,
    theme = _ref2.theme;
  if (inverse) {
    return theme.palette.white;
  }
  return theme.palette[color];
}, function (_ref3) {
  var size = _ref3.size;
  if (size === 'xs') {
    return '.8125rem';
  }
  if (size === 'small') {
    return '1rem';
  }
  if (size === 'medium') {
    return '1.5rem';
  }
  if (size === 'large') {
    return '2rem';
  }
  if (size === 'extraLarge') {
    return '2.3125rem';
  }
  return size;
});
var Icon = function Icon(_ref4) {
  var _ref4$color = _ref4.color,
    color = _ref4$color === void 0 ? DEFAULT_COLOR : _ref4$color,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 'small' : _ref4$size,
    _ref4$theme = _ref4.theme,
    theme = _ref4$theme === void 0 ? themes["default"] : _ref4$theme,
    _ref4$ariaHidden = _ref4.ariaHidden,
    ariaHidden = _ref4$ariaHidden === void 0 ? true : _ref4$ariaHidden,
    rest = _objectWithoutProperties(_ref4, _excluded);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    "aria-hidden": ariaHidden,
    color: color,
    size: size,
    theme: theme
  }, rest, {
    className: className,
    style: style
  }));
};
var _Icon = withDefaultTheme(/*#__PURE__*/memo(Icon));

export default _Icon;
